import { API_URL } from '../../constants/endpoints';
import sessionFetch from '../../middleware/sessionFetch';


const read = async (response) => {
  const json = await response.json();
  if (json.status === 'ok') {
    return { ok: true, data: json.data };
  }
  return { ok: false, error: (json.data && json.data.type) || 'Ошибка сервера' };
};

const safely = async (request) => {
  try {
    return await read(await request());
  } catch (err) {
    return { ok: false, error: `Сервер недоступен: ${err.message}` };
  }
};

export const listImages = () =>
  safely(() => sessionFetch(`${API_URL}/api/whatsapp/images`));

// file: PNG или JPG из <input type="file">, уходит на сервер как есть (байты).
export const uploadImage = (file) =>
  safely(() =>
    sessionFetch(`${API_URL}/api/whatsapp/images`, {
      method: 'POST',
      headers: { 'Content-Type': file.type },
      body: file,
    })
  );

// Готовый макет «Закупка соняшника»: подложка и расстановка текстов.
export const fetchStarter = () =>
  safely(() => sessionFetch(`${API_URL}/api/whatsapp/images-starter`));

export const imagePreviewUrl = (file) => `${API_URL}/api/whatsapp/images/${file}`;

// Границы каждого текста на картинке (доли 0..1), нужны для выравнивания.
export const measureImage = (file, fields, values) =>
  safely(() =>
    sessionFetch(`${API_URL}/api/whatsapp/images/measure`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ file, config: { fields }, values }),
    })
  );

// Шрифты, которыми сервер умеет рисовать текст на картинке.
export const listFonts = () =>
  safely(() => sessionFetch(`${API_URL}/api/whatsapp/image-fonts`));

// Логотип компании как картинка профиля номера: PNG или JPG, уходит как есть (байты).
export const saveProfilePicture = (file) =>
  safely(() =>
    sessionFetch(`${API_URL}/api/whatsapp/account/profile-picture`, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    })
  );
